import { Injectable } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';
import { AppConfigService } from '@edassist/common';
import { GrowthBookAttributes } from '@tuition/app/core/models/growth-book-attributes.interface';

@Injectable({
	providedIn: 'root'
})
export class GrowthBookService {
	readonly growthbook: GrowthBook;
	isInitialized = false;
	initializationPromise: Promise<void> | null = null;

	constructor() {
		this.growthbook = new GrowthBook({
			clientKey: AppConfigService.getSettings().growthBookClientKey
		});
	}

	async initializeGrowthBook(attributes?: GrowthBookAttributes): Promise<void> {
		if (this.isInitialized) {
			if (attributes) {
				this.setAttributes(attributes);
			}

			return Promise.resolve();
		}

		if (this.initializationPromise !== null) {
			return this.initializationPromise;
		}

		this.initializationPromise = (async () => {
			try {
				if (attributes) {
					this.setAttributes(attributes);
				}
				await this.growthbook.init({});
				this.isInitialized = true;
			} catch (error) {
				console.error('Error initializing GrowthBook:', error);
				this.isInitialized = false;
				this.initializationPromise = null;
				throw error;
			}
		})();

		return this.initializationPromise;
	}

	isFeatureEnabled(featureKey: string): boolean {
		return this.growthbook.isOn(featureKey);
	}

	getFeatureValue<T>(featureKey: string, fallback: T): T {
		return this.growthbook.getFeatureValue(featureKey, fallback) as T;
	}

	setAttributes(attributes: GrowthBookAttributes): void {
		this.growthbook.setAttributes(attributes);
	}

	async updateAttributes(data: GrowthBookAttributes) {
		this.setAttributes({
			edaClientId: data.edaClientId,
			edaProductTypeId: data.edaProductTypeId
		});
	}
}
